import { createSlice } from "@reduxjs/toolkit";

export const prestationsSlice = createSlice({
    name: 'prestations',
    initialState: {
        value: null
    },
    reducers: {
        setAccount: (state, action) => {
            console.log(state)
            console.log(action)
        }
    }
})

export const { setAccount } = prestationsSlice.actions

export default prestationsSlice.reducer